export default {
  left_column: {
    title: 'Verifică sold',
    description:
      'Introduceți codul cardului cadou pentru a verifica soldul rămas. Codul se află pe PDF-ul cardului cadou.',
  },
  title: 'Verifică soldul cardului cadou',
  subtitle: 'Introduceți un cod de card cadou pentru a verifica soldul curent',
  error: {
    title: 'Cardul cadou nu a fost găsit!',
    description: 'Introduceți un cod de card cadou valid.',
  },
  gift_card: {
    title: 'Cardul cadou a fost găsit!',
    balance: 'Sold',
    value: 'Valoare',
    expires_at: 'Expiră la',
  },
  form: {
    code: {
      label: 'Cod card cadou',
    },
  },
  buttons: {
    check_balance: 'Verifică soldul',
  },
};
